<template>
    <div>
        <TwTable :searchData="searchData" :tableData="tableData" :tableConfig="tableConfig" :pageConfig="pageConfig"
            :filters="filters" :buttonList="buttonList" @resetBtn="resetBtn" @btnCallFunction="callFunction"
            @handleCellClick="handleCellClick" @handleCurrentChange="handleCurrentChange"
            @handleSelectCheckbox="handleSelectCheckbox" @searchChange="searchChange" @handleSizeChange="handleSizeChange"
            @getTableEle="getTableEle" @handleSelsChange="handleSelsChange" @handleOperateEvent="handleOperateEvent">
            <template slot-scope="scope" slot="batchNo">
                <el-link :underline="false" type="primary" @click.native="batchesDetail(scope.row)">{{
                    scope.row.batchNo }}
                </el-link>
            </template>
            <template slot-scope="scope" slot="fileName">
                <el-link :underline="false" type="primary" @click.native="downFile(scope.row)">{{
                    scope.row.fileName }}
                </el-link>
            </template>
        </TwTable>
        <LogDialog :logPageConfig="logPageConfig" :showLog="showLog" :requestData="{
            businessType: 12,
            businessCode: currentRow.batchNo,
        }" :requestApi="'/WareHouse/BusinessLogServices'" :requestMethod="'get'" v-if="showLog"
            @showDialog="showDialog">
        </LogDialog>
        <!-- 新增弹窗 -->
        <FeeFileConfigureAddDalog ref="FeeFileConfigureAddDalogRef" :customList="customList" :warehouseList="warehouseList"
            @searchTable="initTable" />
        <!-- 编辑、查看弹窗 -->
        <FeeFileConfigureEditDalog ref="FeeFileConfigureEditDalogRef" :EditDalogType="EditDalogType"
            @searchTable="initTable" />
    </div>
</template>
      
<script>
import {
    GetFeeFileListAsync,
    EditServiceStatus,
    UpdateFeeFileStatus,
    CopyFeeFile
} from "@/api/costManagement/FeeFileConfigure.js";
import { getUploadFileInfoBySourceID } from "@/api/api.js";
import LogDialog from "../../components/TwTable/components/logDialog";
import FeeFileConfigureAddDalog from './components/FeeFileConfigureAddDalog.vue'
import FeeFileConfigureEditDalog from './components/FeeFileConfigureEditDalog.vue'
import { getCustomerList } from "@/api/common/common.js";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import { arrToJoin, toSelectOptions, urlEncode, deleteJsonEmptyProps, ToExcel } from "util/util";
export default {
    components: {
        TwTable,
        FeeFileConfigureAddDalog,
        FeeFileConfigureEditDalog,
        LogDialog
    },
    mixins: [TwTable_mixins],
    data() {
        return {
            EditDalogType: '',
            warehouseList: [],
            customList: [],
            tableConfig: {
                showSelection: true, // 显示多选框
                showRadio: true, // 显示单选框
                showResetButton: true,
                showIndex: false, // 显示序号
                loading: false, // 显示loading状态
                showPage: true, // 显示分页
                size: "medium", // table的尺寸  medium / small / mini
                showOperate: true, // 显示操作栏
                operate: {
                    //操作栏配置
                    align: "center",
                    options: [
                        {
                            name: "日志",
                            size: "small",
                            type: "text",
                            event: "getbusinessLoglist", // 操作的事件名
                        },
                    ],
                },
                column: [
                    // 表格列配置
                    {
                        prop: "warehouseName",
                        label: "仓库",
                        minWidth: "80",
                    },
                    {
                        prop: "feeScopeText",
                        label: "报价类型",
                        minWidth: "80",
                    },
                    {
                        prop: "customName",
                        label: "客户货主",
                        minWidth: "80",
                    },
                    {
                        prop: "batchNo",
                        label: "批次号",
                        slot: true,
                        minWidth: "110",
                    },
                    {
                        prop: "fileName",
                        label: "文件名",
                        slot: true,
                        minWidth: "150",
                    },
                    {
                        prop: "feeFileStatusText",
                        label: "状态",
                    },
                    {
                        prop: "effectiveDateDesc",
                        label: "有效期起",
                    },
                    {
                        prop: "expirationDateDesc",
                        label: "有效期止",
                    },
                    {
                        prop: "createTimeDesc",
                        label: "导入时间",
                    },
                    {
                        prop: "createUser",
                        label: "导入用户",
                    }
                ],
            },
            searchData: {
                //搜索列配置
                search: [
                    {
                        type: "select",
                        key: "orgIDs",
                        label: "客户",
                        multiple: true,
                        clearable: true,
                        options: [],
                    },

                    {
                        type: "select",
                        key: "status",
                        label: "状态",
                        multiple: true,
                        clearable: true,
                        options: [
                            {
                                label: "草稿",
                                value: 10,
                            },
                            {
                                label: "待审核",
                                value: 20,
                            },
                            {
                                label: "已审核",
                                value: 30,
                            },
                            {
                                label: "审核拒绝",
                                value: 40,
                            },
                            {
                                label: "启用",
                                value: 50,
                            },
                            {
                                label: "作废",
                                value: 99,
                            },
                        ],
                    },

                    {
                        type: "select",
                        key: "feeScopes",
                        label: "报价类型",
                        multiple: true,
                        clearable: true,
                        options: [
                            {
                                label: "公共报价",
                                value: 0,
                            },
                            {
                                label: "自定义报价",
                                value: 1,
                            }
                        ],
                    },
                    {
                        type: "daterange",
                        key: "date",
                        label: "有效期",
                        clearable: true,
                    },
                    {
                        type: "select",
                        key: "warehouseIds",
                        label: "仓库",
                        multiple: true,
                        clearable: true,
                        options: [],
                    },
                ],
                ///高级搜索配置
                moreSearch: [],
            },
            //-------------
        };
    },
    methods: {
        //查询日志
        getbusinessLoglist(row) {
            this.currentRow = row;
            this.showLog = true;
        },
        callFunction(item) {
            if (item.name === "查询") {
                this.$set(this.pageConfig, "pageIndex", 1);
                this.initTable.apply(this, item);
            } else {
                this[item.func].apply(this, item);
            }
        },
        batchesDetail(rowData) {
            this.EditDalogType = 'view'
            this.$nextTick(() => {
                this.$refs.FeeFileConfigureEditDalogRef.showDalog(rowData)
            })
        },
        downFile(rowData) {
            let data = {
                sourceID: rowData.feeFileInfoID,
                sourceType: 40
            }
            const loading = this.$loading({
                lock: true,
                text: "文件下载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.5)",
            });
            getUploadFileInfoBySourceID(data).then((res) => {
                loading.close();
                if (res.data && res.data.success) {
                    ToExcel(rowData.fileName, res.data.response[0])
                    this.$message({
                        message: "下载成功！",
                        type: "success",
                    });
                } else {
                    this.$message({
                        message: "下载失败！",
                        type: "error",
                    });
                }
            })
        },
        //查询列表
        initTable() {
            const { warehouseIds, orgIDs, status, feeScopes, date } = this.filters;
            let para = {
                page: this.pageConfig.pageIndex,
                pageSize: this.pageConfig.pageSize || 50,
                ...this.filters,
                warehouseIds: arrToJoin(warehouseIds),
                orgIDs: arrToJoin(orgIDs),
                status: arrToJoin(status),
                feeScopes: arrToJoin(feeScopes),
                startdate: date ? date[0] : '',
                enddate: date ? date[1] : '',
            };
            this.getTableData(GetFeeFileListAsync, deleteJsonEmptyProps(para)).then((res) => {
            });
        },
        // 新增
        AddFee() {
            this.$refs.FeeFileConfigureAddDalogRef.showDalog()
        },
        // 编辑
        edidFee() {
            let _this = this
            this.validSelectRows([10], 'feeFileStatus', '只有草稿状态可以操作').then((rowData) => {
                _this.EditDalogType = 'edit'
                _this.$nextTick(() => {
                    _this.$refs.FeeFileConfigureEditDalogRef.showDalog(rowData)
                })
            })
        },
        getButtonIndex(fnName) {
            let fnIndex = 0
            this.buttonList.forEach((item, index) => {
                if (item.func == fnName) {
                    fnIndex = index
                    return
                }
            })
            return fnIndex
        },
        updateRowsStatus(status, btnKey, confirmText, confirmTip) {
            this.$confirm(confirmText || "确认提交吗？", confirmTip || "提示", {}).then(() => {
                this.$set(
                    this.buttonList[this.getButtonIndex(btnKey)],
                    "loading",
                    true
                )
                let feeFileInfoIDs = this.selectRows.rows.map(item => item.feeFileInfoID)
                let params = {
                    feeFileInfoIDs: feeFileInfoIDs.join(','),
                    status
                }
                UpdateFeeFileStatus({}, urlEncode(deleteJsonEmptyProps(params))).then(res => {
                    this.$set(
                        this.buttonList[this.getButtonIndex(btnKey)],
                        "loading",
                        false
                    )
                    if (res.data.success) {
                        this.$message({
                            message: res.data.msg || "操作成功",
                            type: "success",
                        });
                        this.initTable()
                    } else {
                        this.$message({
                            message: res.data.msg || "操作失败",
                            type: "error",
                        });
                    }
                })
            }).catch((err) => {
                console.log(err);
            })

        },
        // 提交审核
        submitApproved() {
            this.validSelectRows([10], 'feeFileStatus', '草稿状态在才能提交审核', true).then((rowData) => {
                // 草稿改成待审核(20)
                this.updateRowsStatus(20, 'submitApproved', '确认提交审核吗?', '提交审核')
            })
        },
        // 审核
        approved() {
            this.validSelectRows([20], 'feeFileStatus', '待审核状态下才能审核', true).then((rowData) => {
                // 审核改成已审核(30)
                this.updateRowsStatus(30, 'approved', '是否审核通过?', '审核')
            })
        },
        // 启用
        feeStart() {
            this.validSelectRows([30], 'feeFileStatus', '只有已审核状态可以启用', true).then((rowData) => {
                // 已审核状改成启用(30)
                this.updateRowsStatus(50, 'feeStart', '是否启用?', '启用')
            })
        },
        // 作废
        feeCancel() {
            this.validSelectRows([10], 'feeFileStatus', '只有草稿状态可以作废', true).then((rowData) => {
                // 草稿改成作废[10]
                this.updateRowsStatus(99, 'feeCancel', '是否作废?', '作废')
            })
        },
        // 复制新增
        copyFee() {
            if (this.selectRows.rows && this.selectRows.rows.length === 1) {
                this.$confirm("确认复制新增吗？", "复制新增", {}).then(() => {
                    this.$set(
                        this.buttonList[this.getButtonIndex('copyFee')],
                        "loading",
                        true
                    )
                    let params = { feeFileInfoID: this.selectRows.rows[0].feeFileInfoID }
                    CopyFeeFile({}, urlEncode(deleteJsonEmptyProps(params))).then(res => {
                        this.$set(
                            this.buttonList[this.getButtonIndex('copyFee')],
                            "loading",
                            false
                        )
                        if (res.data.success) {
                            this.$message({
                                message: res.data.msg || "复制成功",
                                type: "success",
                            });
                            this.initTable()
                        } else {
                            this.$message({
                                message: res.data.msg || "复制失败",
                                type: "error",
                            });
                        }
                    })
                }).catch((err) => {
                    console.log(err);
                })
            } else {
                this.$message({
                    message: '请选择一条数据进行复制',
                    type: "error",
                });
            }

        },

        //单选选中复选框
        handleCellClick(row, column, event) {
            this.tableEle.toggleRowSelection(row);
        },

        // 获取搜索栏下拉框数据
        initDropList() {
            // 设置仓库下拉
            let user = JSON.parse(window.localStorage.user);
            this.warehouseList = toSelectOptions(user.warehouseList, "warehouseId", "warehouseName")
            this.setSearchOptions(
                "search",
                "warehouseIds",
                this.warehouseList
            );


            // 设置客户下拉
            getCustomerList({}).then((res) => {
                this.customList = toSelectOptions(res.data.response, "id", "customName")
                this.setSearchOptions(
                    "search",
                    "orgIDs",
                    this.customList
                );
            });
        },
        resetBtn() {
            this.filters = {};
        },
    },

    mounted() {
        // 获取按钮配置
        this.getMixinsButtonList();
        // 获取搜索栏下拉框数据
        this.initDropList();
    },
};
</script>
    